// Modal v1.4

import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import { TextField } from "@material-ui/core";
import { Formik } from 'formik';
import * as yup from 'yup';

import AppContext from 'app/AppContext';

export function withModal(OriginalComponent) {
    return class extends React.Component {
        state = {
            className: "",
            busy: false,
            message: null,
            show: false,
            title: null,
            header: null,
            view: "",
            footer: null
        }

        onCloseModal = () => {
            this.setState({
                show: false,
            });
        }

        setModalMessage = (message, isBusy = false) => {
            this.setState({
                busy: isBusy,
                message: message
            });
        }

        setFree = () => {
            this.setState({
                busy: false,
                message: null
            });
        }

        setModalBusy = (busy = true) => {
            this.setState({
                busy: busy,
            });
        }
            
        overlay = () => {
            if(this.state.busy || this.state.message != null)
                return (
                    <div className="modal-overlay"
                        ref={el => {
                            if (!el) return;
                            //console.log(el.getBoundingClientRect());
                        }}>
                        {this.state.busy && AppContext.r['preloader']}

                        <div className="message">
                            {this.state.message}
                        </div>
                    </div>);

            return "";
        }

        setModalTitle = (title) => {
            this.setState({
                title: title,
            })
        }

        setModalView = (title, view, show = null, className = null, footer = null) => {
            this.setState({
                title: title,
                view: view,
                show: show ? show : this.state.show,
                className: className ? className : this.state.className,
                footer: footer
            })
        }

        confirm = (title, text, callback) => {
            this.setState({
                title: title,
                view: text,
                footer: (
                    <>
                        <Button variant="secondary" onClick={this.onCloseModal}>
                            {AppContext.r["no"]}
                        </Button>
                        
                        <Button variant="danger" onClick={() => callback()}>
                            {AppContext.r["yes"]}
                        </Button>
                    </>
                ),
                show: true
            })
        }

        input = (title, text, callback) => {
            const form = <Formik className="input-modal"
                initialValues={{
                    inputField: AppContext.r["new-playlist"],
                }}
                validationSchema={
                    yup.object({ inputField: yup.string().required(AppContext.r["required-field"]) })
                }
                onSubmit={async (values) => {
                    await callback(values.inputField)
                }}>
                
                {({ values, touched, errors, handleSubmit, handleChange }) => (
                    <form onSubmit={handleSubmit}>
                        <Row>
                            <Col>
                                {text}
                            </Col>
                        </Row>

                        <TextField
                            fullWidth
                            id="inputField"
                            name="inputField"
                            label={AppContext.r["fill-field"]}
                            value={values.inputField}
                            onChange={handleChange}
                            error={touched.inputField && Boolean(errors.inputField)}
                            helperText={touched.inputField && errors.inputField} />

                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.onCloseModal}>
                                {AppContext.r["cancel"]}
                            </Button>
                        
                            <Button type="submit" variant="success">Okay</Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>;

            this.setState({
                title: title,
                view: form,
                footer: null,
                show: true
            })
        }

        show = (show = true) => {
            this.setState({
                show: show
            })
        }

        hide = () => {
            this.setState({
                show: false,
                busy: false,
                inputField: null
            })
        }

        render() {
            const newProps = {
                modal: {
                    confirm: this.confirm,
                    input: this.input,
                    setMessage: this.setModalMessage,
                    setTitle: this.setModalTitle,
                    setView: this.setModalView,
                    setFree: this.setFree,
                    setBusy: this.setModalBusy,
                    show: this.show,
                    hide: this.hide,
                }
            }

            // Return original component with additional props
            return <>
                    <OriginalComponent {...this.props} {...newProps} />

                    <Modal show={this.state.show} onHide={this.onCloseModal} className={this.state.className}>
                        <Modal.Header closeButton>
                            { this.state.header && this.state.header }
                            { this.state.title && <Modal.Title>{this.state.title}</Modal.Title> }
                        </Modal.Header>
                        
                        <Modal.Body>
                            {this.state.view}
                        </Modal.Body>

                        { this.state.footer &&
                            <Modal.Footer>
                                { this.state.footer }
                            </Modal.Footer> }

                        {this.overlay()}
                    </Modal>
                </>
        }
    }
}

function ModalComponent(props) {

}

export default withModal(ModalComponent);